import React, {Component} from "react";
import {Button, Col, Divider, Form, message, Row, Steps} from 'antd';
import PropTypes from "prop-types";
import style from '../index.css';
import FirstStep from './step-first';
import SecondedStep from './step-second';
import LastStep from './step-last';
import moment from 'moment';
import NHFetch from '../../../../utils/NHFetch';

const basicUrl = '/xxcj/bdgl/';
const Step = Steps.Step;

/**
 * @author weishihuai
 * @date 2018/6/28
 * @time 16:06
 * @Description: 编辑表单配置
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isUpdate: false,    //是否是更新操作
            current: 0,         //当前步骤
            bdjbxxData: {},     //表单基本信息
            bdzdData: [],       //表单对应字段信息
            isSuccess: false,   //是否配置成功
        }
    }

    componentDidMount() {
        if (this.props.initFormData) {
            const initFormData = this.props.initFormData;
            const bdzdData = initFormData.bdzdVOs;
            for (let key in bdzdData) {
                bdzdData[key].editable = false; //编辑模式
            }
            this.setState({
                isUpdate: true,
                bdjbxxData: initFormData.bdglVO,
                bdzdData: bdzdData,
            });
        }
    }

    //下一步
    next = () => {
        const current = this.state.current + 1;
        if (this.state.current === 0) {
            //保存表单基本数据
            this.saveBdxx(current);
        } else {
            this.setState({current});
        }
    };

    //上一步
    prev = () => {
        const current = this.state.current - 1;
        this.setState({current});
    };

    //保存表单基本信息
    saveBdxx = (current) => {
        this.firstStepForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            const {kssj, jssj, zt} = formData;

            if (kssj && !jssj) {
                message.error('请填写采集结束时间！');
                return;
            }

            if (!kssj && jssj) {
                message.error('请填写采集开始时间！');
                return;
            }

            if (kssj && jssj) {
                if (moment(kssj) > moment(jssj)) {
                    message.error('采集开始时间不能大于结束时间！');
                    return;
                }

                let startTime = moment(kssj).format('YYYY-MM-DD HH:mm:ss');
                let endTime = moment(jssj).format('YYYY-MM-DD HH:mm:ss');
                formData.kssj = startTime;
                formData.jssj = endTime;
            }

            formData.zt = zt ? '1' : '0';
            this.setState({bdjbxxData: {...this.state.bdjbxxData, ...formData}});
            this.setState({current});
        });
    };

    //表单配置信息改变时回调
    handleBdjbxxChange = (values) => {
        this.setState({bdjbxxData: {...this.state.bdjbxxData, ...values}});
    };

    //表单字段配置信息改变时回调
    handleBdzdChange = (bdzdData) => {
        this.setState({bdzdData: bdzdData});
    };

    //完成
    handleFinish = () => {
        let {bdjbxxData, bdzdData} = this.state;
        let formData = {...bdjbxxData, bdzdList: [...bdzdData]};
        this.secondedStepForm.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            formData['bdzdList'] = [...fieldsValue];

            for (let i = 0; i < formData.bdzdList.length; i++) {
                let data = formData.bdzdList[i];
                if (data && data.zdzt === '') {
                    data.zdzt = '1';
                }
                if (data && data.sfbt === '') {
                    data.sfbt = '0';
                }
            }

            let url = basicUrl + (this.state.isUpdate ? 'update' : 'insert');
            NHFetch(url, 'POST', formData)
                .then(res => {
                    if (res) {
                        if (res.data === 1) {
                            this.setState({isSuccess: true});
                        }
                        this.next();
                    }
                });
        });
    };

    //是否继续添加
    handleReset = () => {
        this.setState({
            isUpdate: false,  //是否是更新操作
            current: 0,       //当前步骤
            bdjbxxData: {},   //表单基本信息
            bdzdData: [],     //表单对应字段信息
            isSuccess: false, //是否配置成功
        });
    };

    //步骤一:表单基本信息
    getFirstContent() {
        return <FirstStep ref={(form) => this.firstStepForm = form} onChange={this.handleBdjbxxChange}
                          data={this.state.bdjbxxData} update={this.state.isUpdate}/>;
    }

    //步骤二:表单字段信息
    getSecondContent() {
        return <SecondedStep ref={(form) => this.secondedStepForm = form} data={this.state.bdzdData}
                             onChange={this.handleBdzdChange} update={this.state.isUpdate}/>
    }

    //最后一步:完成操作
    getLastContent() {
        return <LastStep update={this.state.isUpdate} status={this.state.isSuccess} onReset={this.handleReset}/>
    }

    render() {
        const {current} = this.state;

        const steps = [{
            title: '表单定义',
            content: this.getFirstContent(),
            description: '说明：表单名称不宜过长，名称含义应简短明确。'
        }, {
            title: '表单字段设置',
            content: this.getSecondContent(),
            description: '说明：请设置表单的字段。'
        }, {
            title: '完成',
            content: this.getLastContent(),
        }];

        return (
            <div>
                <Row type="flex" justify="center">
                    <Col span={24}>
                        <Steps current={current}>
                            {steps.map(item => <Step key={item.title} title={item.title}/>)}
                        </Steps>
                        <div className={style["steps-content"]}>
                            {steps[this.state.current].content}
                        </div>
                        <div className={style["steps-action"]}>
                            {
                                this.state.current > 0 && this.state.current < steps.length - 1
                                &&
                                <Button style={{marginRight: 8}} onClick={this.prev}>
                                    上一步
                                </Button>
                            }
                            {
                                this.state.current < steps.length - 2
                                &&
                                <Button type="primary" style={{marginRight: 8}} onClick={this.next}>下一步</Button>
                            }
                            {
                                this.state.current === steps.length - 2
                                &&
                                <Button type="primary" onClick={this.handleFinish}>完成</Button>
                            }
                        </div>
                        {
                            (this.state.current < steps.length - 1) && <Divider/>
                        }
                        <div className={style["steps-description"]}>
                            <p>{steps[this.state.current].description}</p>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

EditInitForm.propTypes = {
    initFormData: PropTypes.object, //初始数据
};

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/xxcj/bdgl/edit-form/EditForm.js